import { createContext } from "react"

export type CateringCheckoutInput = {
  name: string
  label: string
  helperText: string
  placeholder: string
}

export type CateringPaymentMethod = "ean" | "credit_card"

export type CateringContextType = {
  checkoutCateringDescription: string
  isCatering: boolean
  menuPageCateringDescription: string
  checkoutInputs: CateringCheckoutInput[]
  cateringOrderWindowStartInDays: number
  cateringOrderWindowEndInDays: number
  cateringPaymentMethods: CateringPaymentMethod[]
}

const defaultContext: CateringContextType = {
  checkoutCateringDescription: "",
  isCatering: false,
  menuPageCateringDescription: "",
  checkoutInputs: [],
  cateringOrderWindowStartInDays: 0,
  cateringOrderWindowEndInDays: 0,
  cateringPaymentMethods: ["ean"],
}

export const CateringContext = createContext(defaultContext)
